<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home']" :titlePrefix="domainConfig?.siteName || 'Home'">
    <Banner :bannerMovies="bannerMovies" />

    <PopularMovie class="common-gap" :movies="movies" @more="navigateTo('popular', 'movie')" />
    <NowPlaying class="common-gap" :movies="nowPlayingMovies"
      @more="navigateTo('now-playing', 'movie')" />
    <TopRatedMovie class="common-gap" :movies="topRatedMovies"
      @more="navigateTo('top-rated', 'movie')" />
    <PopularTv class="common-gap" :shows="tvShows" @more="navigateTo('popular', 'tv')" />
    <PlayingTV class="common-gap" :shows="playingTVShows" @more="navigateTo('now-playing', 'tv')" />
    <TopRated class="common-gap" :shows="topRatedShows" @more="navigateTo('top-rated', 'tv')" />
    <AboutUs class="common-gap" />

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import Banner from '@/components/Banner.vue'
import PopularMovie from '@/components/PopularMovie.vue';
import NowPlaying from '@/components/NowPlaying.vue';
import TopRatedMovie from '@/components/TopRatedMovie.vue';
import PopularTv from '@/components/PopularTv.vue';
import PlayingTV from '@/components/PlayingTV.vue';
import TopRated from '@/components/TopRated.vue';
import AboutUs from '@/components/AboutUs.vue';

import '@/css/home.scss';
import '@/css/common.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
    Banner,
    PopularMovie,
    NowPlaying,
    TopRatedMovie,
    PopularTv,
    PlayingTV,
    TopRated,
    AboutUs
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      bannerMovies: [],
      movies: [],
      nowPlayingMovies: [],
      topRatedMovies: [],
      tvShows: [],
      playingTVShows: [],
      topRatedShows: []
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }

    // 获取数据
    this.fetchData();
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }

    // 获取数据
    this.fetchData();
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }
  },
  methods: {
    // 跳转到更多页面
    navigateTo (rank, type) {
      if (type === 'movie') {
        if (rank === 'popular') {
          this.$router.push({ path: `/movies/popular-movies/` });
        } else if (rank === 'now-playing') {
          this.$router.push({ path: `/movies/now-playing-movies/` });
        } else if (rank === 'top-rated') {
          this.$router.push({ path: `/movies/top-rated-movies/` });
        }
      } else if (type === 'tv') {
        if (rank === 'popular') {
          this.$router.push({ path: `/tv-shows/popular-tv-shows/` });
        } else if (rank === 'now-playing') {
          this.$router.push({ path: `/tv-shows/now-playing-tv-shows/` });
        } else if (rank === 'top-rated') {
          this.$router.push({ path: `/tv-shows/top-rated-tv-shows/` });
        }
      }
    },

    // 获取所有数据
    fetchData () {
      this.fetchBannerMovies();
      this.fetchPopularMovies();
      this.fetchNowPlayingMovies();
      this.fetchTopRatedMovies();
      this.fetchPopularTVShows();
      this.fetchPlayingTVShows();
      this.fetchTopRatedTVShows();
    },

    // 获取Banner电影数据（Popular Movies第一页）
    fetchBannerMovies () {
      const params = {
        page: 1
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/movie/popular',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Banner Movies 获取成功:', response.results);

            // 转换数据格式
            this.bannerMovies = response.results.slice(0, 5).map(movie => ({
              id: movie.id,
              title: movie.title,
              image: `https://image.filmzillaxtra.com/t/p/w1066_and_h600_bestv2${movie.backdrop_path}`,
              rating: movie.vote_average.toFixed(1),
              releaseDate: movie.release_date,
              genre: this.getGenreName(movie.genre_ids, 'movie'),
              description: movie.overview
            }));
          }
        })
        .catch(error => {
          console.error('获取Banner Movies失败:', error);
        });
    },

    // 获取Popular Movies数据（第二页）
    fetchPopularMovies () {
      const params = {
        page: 2
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/movie/popular',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Popular Movies 获取成功:', response.results);

            // 转换数据格式
            this.movies = response.results.slice(0, 10).map(movie => ({
              id: movie.id,
              title: movie.title,
              category: this.getGenreName(movie.genre_ids, 'movie'),
              date: movie.release_date,
              score: movie.vote_average.toFixed(1),
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face${movie.poster_path}`
            }));
          }
        })
        .catch(error => {
          console.error('获取Popular Movies失败:', error);
        });
    },

    // 获取Now Playing Movies数据
    fetchNowPlayingMovies () {
      const params = {
        page: 1
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/movie/now_playing',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Now Playing Movies 获取成功:', response.results);

            // 转换数据格式
            this.nowPlayingMovies = response.results.slice(0, 10).map(movie => ({
              id: movie.id,
              title: movie.title,
              date: movie.release_date,
              score: movie.vote_average.toFixed(1),
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face${movie.poster_path}`
            }));
          }
        })
        .catch(error => {
          console.error('获取Now Playing Movies失败:', error);
        });
    },

    // 获取Top Rated Movies数据
    fetchTopRatedMovies () {
      const params = {
        page: 1
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/movie/top_rated',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Top Rated Movies 获取成功:', response.results);

            // 转换数据格式
            this.topRatedMovies = response.results.slice(0, 10).map(movie => ({
              id: movie.id,
              title: movie.title,
              date: movie.release_date,
              score: movie.vote_average.toFixed(1),
              genre: this.getGenreName(movie.genre_ids, 'movie'),
              description: movie.overview,
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face${movie.poster_path}`
            }));

            // 设置背景图片
            if (this.topRatedMovies.length > 0) {
              document.documentElement.style.setProperty('--bg-image', `url(${this.topRatedMovies[0].poster})`);
            }
          }
        })
        .catch(error => {
          console.error('获取Top Rated Movies失败:', error);
        });
    },

    // 获取Popular TV Shows数据
    fetchPopularTVShows () {
      const params = {
        page: 1
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/tv/popular',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Popular TV Shows 获取成功:', response.results);

            // 转换数据格式
            this.tvShows = response.results.slice(0, 10).map(show => ({
              id: show.id,
              title: show.name,
              date: show.first_air_date,
              score: show.vote_average.toFixed(1),
              genre: this.getGenreName(show.genre_ids, 'tv'),
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face${show.poster_path}`
            }));
          }
        })
        .catch(error => {
          console.error('获取Popular TV Shows失败:', error);
        });
    },

    // 获取Now Playing TV Shows数据
    fetchPlayingTVShows () {
      const params = {
        page: 1
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/tv/on_the_air',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Now Playing TV Shows 获取成功:', response.results);

            // 转换数据格式
            this.playingTVShows = response.results.slice(0, 10).map(show => ({
              id: show.id,
              title: show.name,
              date: show.first_air_date,
              score: show.vote_average.toFixed(1),
              genre: this.getGenreName(show.genre_ids, 'tv'),
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face${show.poster_path}`
            }));
          }
        })
        .catch(error => {
          console.error('获取Now Playing TV Shows失败:', error);
        });
    },

    // 获取Top Rated TV Shows数据
    fetchTopRatedTVShows () {
      const params = {
        page: 1
      };

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: params,
        url: '/3/tv/top_rated',
      })
        .then(response => {
          if (response && response.results) {
            console.log('Top Rated TV Shows 获取成功:', response.results);

            // 转换数据格式
            this.topRatedShows = response.results.slice(0, 10).map(show => ({
              id: show.id,
              title: show.name,
              date: show.first_air_date,
              score: show.vote_average.toFixed(1),
              genre: this.getGenreName(show.genre_ids, 'tv'),
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face${show.poster_path}`
            }));
          }
        })
        .catch(error => {
          console.error('获取Top Rated TV Shows失败:', error);
        });
    },

    // 根据类型ID获取类型名称
    getGenreName (genreIds, type) {
      if (!genreIds || !Array.isArray(genreIds) || genreIds.length === 0) {
        return 'Unknown';
      }

      // 获取类型列表
      const genreList = type === 'movie' ? this.$store.getters.MovieGenres : this.$store.getters.tvGenres;

      // 如果类型列表为空，返回Unknown
      if (!genreList || genreList.length === 0) {
        return 'Unknown';
      }

      // 只取第一个类型ID进行显示
      const genreId = genreIds[0];
      const genre = genreList.find(g => g.id === genreId);

      return genre ? genre.name : 'Unknown';
    }
  }
};
</script>
